<script setup>
	const error = useError()
	const pageNotFound = computed(() => Number(error.value?.statusCode ?? 0) === 404)
</script>
<template>
	<div>
		<header-nav />
		<div
			class="flex min-h-screen flex-col lg:flex-row items-center justify-center max-w-[90vw] xl:max-w-[1160px] mx-auto"
		>
			<div class="h-full flex-1 space-y-5 flex flex-col justify-center order-last lg:order-first mb-3 md:mb-0">
				<h2
					class="text-3xl md:pb-5 md:text-[48px] text-mca-black font-semibold md:max-w-[432px] leading-[32px] md:leading-[48px] mx-auto lg:mx-0"
				>
					{{ pageNotFound ? 'Page Not Found:' : 'Something went wrong' }}
				</h2>

				<p class="mt-[50px]">
					{{
						pageNotFound
							? 'The page you are looking for could not be found. It may have been removed, renamed, or is temporarily unavailable. Please check the URL for any spelling mistakes or try the following:'
							: 'We are working on this right now and will get back to you as soon as possible.'
					}}
				</p>

				<ul class="list-disc list-outside ms-4">
					<li>Go back to the previous page and try again.</li>
					<li>Navigate to the homepage and browse from there.</li>
				</ul>

				<p class="mt-2">
					If you believe this is an error, please contact the website administrator for assistance.
				</p>

				<p class="text-mca mt-3">We apologize for any inconvenience.</p>

				<div class="pt-4 w-full lg:block flex flex-col justify-center items-center">
					<nuxt-link
						to="/"
						class="w-full max-w-[280px] p-[12px_20px] bg-main !text-white flex justify-center rounded-[40px] hover:bg-base-primary transition"
					>
						Go Back Home
					</nuxt-link>
				</div>
			</div>

			<div class="h-full flex-1 flex justify-center items-center">
				<tools-icon dir="random" icon="crash" svg-class="w-[80%] lg:w-auto mx-auto" height="400" width="400" />
			</div>
		</div>
		<footer-base />
	</div>
</template>
